// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"wedding-landing-page_carouselWrapper__3AJ-V","title":"wedding-landing-page_title__15eAz"};